import React from "react";
import {useDispatch} from "react-redux";
import {useHistory} from "react-router-dom";
import {Avatar, Popover, Typography} from "antd";
import {userSignOut} from "appRedux/actions/Auth";
import AttendanceModal from "../../routes/Attendance/AttendanceModal";
import { removeXMPP } from '../../chatServices/XMPPservice';
import { resetChatData } from '../../appRedux/actions/Chat';

const {Text, Paragraph} = Typography;
const UserProfile = (info) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const role_count = info.info.all_roles?info.info.all_roles.length:0
  const switchUser=()=>{
    localStorage.removeItem("user_role")
    localStorage.removeItem("loged_in_to")
    
    history.push('/interstitial')
  }

  const userMenuOptions = (
    <ul className="gx-user-popover">
      <li onClick={() => { 
        localStorage.clear();
        history.push('/portals');
        console.log("LocalStorage cleared");
        removeXMPP();
        dispatch(resetChatData());
      }}>
        Logout
      </li>
      {role_count > 0 && 
        <li onClick={switchUser}>
          Switch Portal
        </li>
      }
      {/* <li>
        <AttendanceModal/>
      </li> */}
    </ul>
  );


  info = info["info"]

  const text_truncate = (str, length, ending) => {
      if (length == null) {
        length = 100;
      }
      if (ending == null) {
        ending = '...';
      }
      if (str.length > length) {
        return str.substring(0, length - ending.length) + ending;
      } else {
        return str;
      }
    };

  return (

    <div className="gx-flex-row gx-align-items-center gx-mb-4 gx-avatar-row">
      <Popover placement="bottomRight" content={userMenuOptions} trigger="click">
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <Avatar src={require("assets/images/avatar/default_user_img.png")}
                  className="gx-size-30 gx-pointer gx-mr-2" alt="profile"/>
          <span className="gx-avatar-name gx-mr-2" style={{}}>
             <Paragraph style={{color:'#038fdd', paddingTop: '5px'}}>{info.fullname ? info.fullname : info.email}</Paragraph>

          </span>
          <span className="gx-pointer" style={{paddingTop: '5px'}}><i className="icon icon-chevron-down gx-fs-xxs" /></span>
        </div>
      </Popover>
      
    </div>

  )
};

export default UserProfile;
